<div>
    <div class="printPres-iframeDiv" style="height: 50rem;">
         <iframe style="width: 100%;height: 100%;border: 0px solid"
             [src]="currentProjectUrl">
         </iframe>
     </div>
 </div>